// source: pbtypes/vehicle/skills/actions/trajectory_inspect/trajectory_inspect.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_scan_planner_scan_waypoint_pb = require('../../../../../pbtypes/gen/scan_planner/scan_waypoint_pb.js');
goog.object.extend(proto, pbtypes_gen_scan_planner_scan_waypoint_pb);
var pbtypes_gen_uuid_util_uuid_pb = require('../../../../../pbtypes/gen/uuid_util/uuid_pb.js');
goog.object.extend(proto, pbtypes_gen_uuid_util_uuid_pb);
var pbtypes_gen_scan_planner_scan_photo_pb = require('../../../../../pbtypes/gen/scan_planner/scan_photo_pb.js');
goog.object.extend(proto, pbtypes_gen_scan_planner_scan_photo_pb);
var pbtypes_util_trajectory_action_planner_trajectory_action_planner_pb = require('../../../../../pbtypes/util/trajectory_action_planner/trajectory_action_planner_pb.js');
goog.object.extend(proto, pbtypes_util_trajectory_action_planner_trajectory_action_planner_pb);
var pbtypes_vehicle_skills_waypoints_pb = require('../../../../../pbtypes/vehicle/skills/waypoints_pb.js');
goog.object.extend(proto, pbtypes_vehicle_skills_waypoints_pb);
goog.exportSymbol('proto.skills.InspectFailureReason', null, global);
goog.exportSymbol('proto.skills.TrajectoryInspectActionArgs', null, global);
goog.exportSymbol('proto.skills.TrajectoryInspectActionStateData', null, global);
goog.exportSymbol('proto.skills.TrajectoryInspectResultData', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.TrajectoryInspectActionArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.skills.TrajectoryInspectActionArgs.repeatedFields_, null);
};
goog.inherits(proto.skills.TrajectoryInspectActionArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.TrajectoryInspectActionArgs.displayName = 'proto.skills.TrajectoryInspectActionArgs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.TrajectoryInspectResultData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.skills.TrajectoryInspectResultData.repeatedFields_, null);
};
goog.inherits(proto.skills.TrajectoryInspectResultData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.TrajectoryInspectResultData.displayName = 'proto.skills.TrajectoryInspectResultData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.TrajectoryInspectActionStateData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.TrajectoryInspectActionStateData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.TrajectoryInspectActionStateData.displayName = 'proto.skills.TrajectoryInspectActionStateData';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.skills.TrajectoryInspectActionArgs.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.TrajectoryInspectActionArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.TrajectoryInspectActionArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.TrajectoryInspectActionArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TrajectoryInspectActionArgs.toObject = function(includeInstance, msg) {
  var f, obj = {
scanWaypointsList: jspb.Message.toObjectList(msg.getScanWaypointsList(),
    pbtypes_gen_scan_planner_scan_waypoint_pb.ScanWaypoint.toObject, includeInstance),
trajectoryActionPlanSettings: (f = msg.getTrajectoryActionPlanSettings()) && pbtypes_util_trajectory_action_planner_trajectory_action_planner_pb.PlanSettings.toObject(includeInstance, f),
frame: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.TrajectoryInspectActionArgs}
 */
proto.skills.TrajectoryInspectActionArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.TrajectoryInspectActionArgs;
  return proto.skills.TrajectoryInspectActionArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.TrajectoryInspectActionArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.TrajectoryInspectActionArgs}
 */
proto.skills.TrajectoryInspectActionArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_scan_planner_scan_waypoint_pb.ScanWaypoint;
      reader.readMessage(value,pbtypes_gen_scan_planner_scan_waypoint_pb.ScanWaypoint.deserializeBinaryFromReader);
      msg.addScanWaypoints(value);
      break;
    case 2:
      var value = new pbtypes_util_trajectory_action_planner_trajectory_action_planner_pb.PlanSettings;
      reader.readMessage(value,pbtypes_util_trajectory_action_planner_trajectory_action_planner_pb.PlanSettings.deserializeBinaryFromReader);
      msg.setTrajectoryActionPlanSettings(value);
      break;
    case 3:
      var value = /** @type {!proto.skills.FrameType.Enum} */ (reader.readEnum());
      msg.setFrame(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.TrajectoryInspectActionArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.TrajectoryInspectActionArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.TrajectoryInspectActionArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TrajectoryInspectActionArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScanWaypointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      pbtypes_gen_scan_planner_scan_waypoint_pb.ScanWaypoint.serializeBinaryToWriter
    );
  }
  f = message.getTrajectoryActionPlanSettings();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_util_trajectory_action_planner_trajectory_action_planner_pb.PlanSettings.serializeBinaryToWriter
    );
  }
  f = message.getFrame();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * repeated scan_planner.ScanWaypoint scan_waypoints = 1;
 * @return {!Array<!proto.scan_planner.ScanWaypoint>}
 */
proto.skills.TrajectoryInspectActionArgs.prototype.getScanWaypointsList = function() {
  return /** @type{!Array<!proto.scan_planner.ScanWaypoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_scan_planner_scan_waypoint_pb.ScanWaypoint, 1));
};


/**
 * @param {!Array<!proto.scan_planner.ScanWaypoint>} value
 * @return {!proto.skills.TrajectoryInspectActionArgs} returns this
*/
proto.skills.TrajectoryInspectActionArgs.prototype.setScanWaypointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.scan_planner.ScanWaypoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.scan_planner.ScanWaypoint}
 */
proto.skills.TrajectoryInspectActionArgs.prototype.addScanWaypoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.scan_planner.ScanWaypoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.skills.TrajectoryInspectActionArgs} returns this
 */
proto.skills.TrajectoryInspectActionArgs.prototype.clearScanWaypointsList = function() {
  return this.setScanWaypointsList([]);
};


/**
 * optional trajectory_action_planner.PlanSettings trajectory_action_plan_settings = 2;
 * @return {?proto.trajectory_action_planner.PlanSettings}
 */
proto.skills.TrajectoryInspectActionArgs.prototype.getTrajectoryActionPlanSettings = function() {
  return /** @type{?proto.trajectory_action_planner.PlanSettings} */ (
    jspb.Message.getWrapperField(this, pbtypes_util_trajectory_action_planner_trajectory_action_planner_pb.PlanSettings, 2));
};


/**
 * @param {?proto.trajectory_action_planner.PlanSettings|undefined} value
 * @return {!proto.skills.TrajectoryInspectActionArgs} returns this
*/
proto.skills.TrajectoryInspectActionArgs.prototype.setTrajectoryActionPlanSettings = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.TrajectoryInspectActionArgs} returns this
 */
proto.skills.TrajectoryInspectActionArgs.prototype.clearTrajectoryActionPlanSettings = function() {
  return this.setTrajectoryActionPlanSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.TrajectoryInspectActionArgs.prototype.hasTrajectoryActionPlanSettings = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional FrameType.Enum frame = 3;
 * @return {!proto.skills.FrameType.Enum}
 */
proto.skills.TrajectoryInspectActionArgs.prototype.getFrame = function() {
  return /** @type {!proto.skills.FrameType.Enum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.skills.FrameType.Enum} value
 * @return {!proto.skills.TrajectoryInspectActionArgs} returns this
 */
proto.skills.TrajectoryInspectActionArgs.prototype.setFrame = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.skills.TrajectoryInspectResultData.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.TrajectoryInspectResultData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.TrajectoryInspectResultData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.TrajectoryInspectResultData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TrajectoryInspectResultData.toObject = function(includeInstance, msg) {
  var f, obj = {
completedWaypointUuidsList: jspb.Message.toObjectList(msg.getCompletedWaypointUuidsList(),
    pbtypes_gen_uuid_util_uuid_pb.Uuid.toObject, includeInstance),
photosList: jspb.Message.toObjectList(msg.getPhotosList(),
    pbtypes_gen_scan_planner_scan_photo_pb.ScanPhoto.toObject, includeInstance),
failureReason: jspb.Message.getFieldWithDefault(msg, 3, 0),
inspectionTimeS: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.TrajectoryInspectResultData}
 */
proto.skills.TrajectoryInspectResultData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.TrajectoryInspectResultData;
  return proto.skills.TrajectoryInspectResultData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.TrajectoryInspectResultData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.TrajectoryInspectResultData}
 */
proto.skills.TrajectoryInspectResultData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_uuid_util_uuid_pb.Uuid;
      reader.readMessage(value,pbtypes_gen_uuid_util_uuid_pb.Uuid.deserializeBinaryFromReader);
      msg.addCompletedWaypointUuids(value);
      break;
    case 2:
      var value = new pbtypes_gen_scan_planner_scan_photo_pb.ScanPhoto;
      reader.readMessage(value,pbtypes_gen_scan_planner_scan_photo_pb.ScanPhoto.deserializeBinaryFromReader);
      msg.addPhotos(value);
      break;
    case 3:
      var value = /** @type {!proto.skills.InspectFailureReason} */ (reader.readEnum());
      msg.setFailureReason(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInspectionTimeS(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.TrajectoryInspectResultData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.TrajectoryInspectResultData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.TrajectoryInspectResultData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TrajectoryInspectResultData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompletedWaypointUuidsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      pbtypes_gen_uuid_util_uuid_pb.Uuid.serializeBinaryToWriter
    );
  }
  f = message.getPhotosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      pbtypes_gen_scan_planner_scan_photo_pb.ScanPhoto.serializeBinaryToWriter
    );
  }
  f = message.getFailureReason();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getInspectionTimeS();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * repeated uuid_util.Uuid completed_waypoint_uuids = 1;
 * @return {!Array<!proto.uuid_util.Uuid>}
 */
proto.skills.TrajectoryInspectResultData.prototype.getCompletedWaypointUuidsList = function() {
  return /** @type{!Array<!proto.uuid_util.Uuid>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_uuid_util_uuid_pb.Uuid, 1));
};


/**
 * @param {!Array<!proto.uuid_util.Uuid>} value
 * @return {!proto.skills.TrajectoryInspectResultData} returns this
*/
proto.skills.TrajectoryInspectResultData.prototype.setCompletedWaypointUuidsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.uuid_util.Uuid=} opt_value
 * @param {number=} opt_index
 * @return {!proto.uuid_util.Uuid}
 */
proto.skills.TrajectoryInspectResultData.prototype.addCompletedWaypointUuids = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.uuid_util.Uuid, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.skills.TrajectoryInspectResultData} returns this
 */
proto.skills.TrajectoryInspectResultData.prototype.clearCompletedWaypointUuidsList = function() {
  return this.setCompletedWaypointUuidsList([]);
};


/**
 * repeated scan_planner.ScanPhoto photos = 2;
 * @return {!Array<!proto.scan_planner.ScanPhoto>}
 */
proto.skills.TrajectoryInspectResultData.prototype.getPhotosList = function() {
  return /** @type{!Array<!proto.scan_planner.ScanPhoto>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_scan_planner_scan_photo_pb.ScanPhoto, 2));
};


/**
 * @param {!Array<!proto.scan_planner.ScanPhoto>} value
 * @return {!proto.skills.TrajectoryInspectResultData} returns this
*/
proto.skills.TrajectoryInspectResultData.prototype.setPhotosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.scan_planner.ScanPhoto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.scan_planner.ScanPhoto}
 */
proto.skills.TrajectoryInspectResultData.prototype.addPhotos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.scan_planner.ScanPhoto, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.skills.TrajectoryInspectResultData} returns this
 */
proto.skills.TrajectoryInspectResultData.prototype.clearPhotosList = function() {
  return this.setPhotosList([]);
};


/**
 * optional InspectFailureReason failure_reason = 3;
 * @return {!proto.skills.InspectFailureReason}
 */
proto.skills.TrajectoryInspectResultData.prototype.getFailureReason = function() {
  return /** @type {!proto.skills.InspectFailureReason} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.skills.InspectFailureReason} value
 * @return {!proto.skills.TrajectoryInspectResultData} returns this
 */
proto.skills.TrajectoryInspectResultData.prototype.setFailureReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 inspection_time_s = 4;
 * @return {number}
 */
proto.skills.TrajectoryInspectResultData.prototype.getInspectionTimeS = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.TrajectoryInspectResultData} returns this
 */
proto.skills.TrajectoryInspectResultData.prototype.setInspectionTimeS = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.TrajectoryInspectActionStateData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.TrajectoryInspectActionStateData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.TrajectoryInspectActionStateData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TrajectoryInspectActionStateData.toObject = function(includeInstance, msg) {
  var f, obj = {
lastCompletedWaypointIdx: jspb.Message.getFieldWithDefault(msg, 1, 0),
estimatedTimeToCompletionS: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
numPhotoWaypointsCaptured: jspb.Message.getFieldWithDefault(msg, 3, 0),
numPhotoWaypointsFailedOrSkipped: jspb.Message.getFieldWithDefault(msg, 4, 0),
numConsecutiveStuckPhotoWaypoints: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.TrajectoryInspectActionStateData}
 */
proto.skills.TrajectoryInspectActionStateData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.TrajectoryInspectActionStateData;
  return proto.skills.TrajectoryInspectActionStateData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.TrajectoryInspectActionStateData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.TrajectoryInspectActionStateData}
 */
proto.skills.TrajectoryInspectActionStateData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLastCompletedWaypointIdx(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setEstimatedTimeToCompletionS(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumPhotoWaypointsCaptured(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumPhotoWaypointsFailedOrSkipped(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumConsecutiveStuckPhotoWaypoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.TrajectoryInspectActionStateData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.TrajectoryInspectActionStateData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.TrajectoryInspectActionStateData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TrajectoryInspectActionStateData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLastCompletedWaypointIdx();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getEstimatedTimeToCompletionS();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getNumPhotoWaypointsCaptured();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getNumPhotoWaypointsFailedOrSkipped();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getNumConsecutiveStuckPhotoWaypoints();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
};


/**
 * optional int32 last_completed_waypoint_idx = 1;
 * @return {number}
 */
proto.skills.TrajectoryInspectActionStateData.prototype.getLastCompletedWaypointIdx = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.TrajectoryInspectActionStateData} returns this
 */
proto.skills.TrajectoryInspectActionStateData.prototype.setLastCompletedWaypointIdx = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional float estimated_time_to_completion_s = 2;
 * @return {number}
 */
proto.skills.TrajectoryInspectActionStateData.prototype.getEstimatedTimeToCompletionS = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.TrajectoryInspectActionStateData} returns this
 */
proto.skills.TrajectoryInspectActionStateData.prototype.setEstimatedTimeToCompletionS = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional uint32 num_photo_waypoints_captured = 3;
 * @return {number}
 */
proto.skills.TrajectoryInspectActionStateData.prototype.getNumPhotoWaypointsCaptured = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.TrajectoryInspectActionStateData} returns this
 */
proto.skills.TrajectoryInspectActionStateData.prototype.setNumPhotoWaypointsCaptured = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 num_photo_waypoints_failed_or_skipped = 4;
 * @return {number}
 */
proto.skills.TrajectoryInspectActionStateData.prototype.getNumPhotoWaypointsFailedOrSkipped = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.TrajectoryInspectActionStateData} returns this
 */
proto.skills.TrajectoryInspectActionStateData.prototype.setNumPhotoWaypointsFailedOrSkipped = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 num_consecutive_stuck_photo_waypoints = 5;
 * @return {number}
 */
proto.skills.TrajectoryInspectActionStateData.prototype.getNumConsecutiveStuckPhotoWaypoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.TrajectoryInspectActionStateData} returns this
 */
proto.skills.TrajectoryInspectActionStateData.prototype.setNumConsecutiveStuckPhotoWaypoints = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * @enum {number}
 */
proto.skills.InspectFailureReason = {
  NO_FAILURE: 0,
  STUCK: 1,
  PHOTO_FAILURE: 2,
  PROGRESS_TIMEOUT: 3,
  INVALID_INPUT: 4
};

goog.object.extend(exports, proto.skills);
